// Product page bundle — metafield products + size select + checkboxes
(function() {
  if (window.__productBundleUpsellInit) return;
  if (!document.querySelector('[data-product-bundle-catalog]')) return;
  window.__productBundleUpsellInit = true;

  var masterCatalog = null;
  var lastCart = null;

  function getCartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }
    return '/cart/add.js';
  }

  function getRoot() {
    return document.querySelector('[data-product-bundle-upsell]');
  }

  function getCatalogEl() {
    return document.querySelector('[data-product-bundle-catalog]');
  }

  function normalizeId(id) {
    return parseInt(id, 10);
  }

  function parseCatalogFromDom() {
    var el = getCatalogEl();
    if (!el) return { items: [], currentProductId: null };
    try {
      return {
        items: JSON.parse(el.textContent) || [],
        currentProductId: normalizeId(el.getAttribute('data-current-product-id'))
      };
    } catch (e) {
      return { items: [], currentProductId: null };
    }
  }

  function getCatalog() {
    if (!masterCatalog) {
      masterCatalog = parseCatalogFromDom();
    }
    return masterCatalog;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return 'Rs.' + (cents / 100).toLocaleString();
  }

  function getOptionLabel(item) {
    var name = item.optionName || 'Size';
    if (name === 'Title' || name === 'Default Title') return 'Size';
    return name;
  }

  function getVariantDisplayLabel(variant, item) {
    if (item.variants && item.variants.length && !variant.option2 && variant.option1) {
      return variant.option1;
    }
    return variant.title;
  }

  function getFirstAvailableVariant(item) {
    if (!item.variants || !item.variants.length) {
      return { id: item.variantId, price: item.price, priceFormatted: item.priceFormatted, available: item.available };
    }
    for (var i = 0; i < item.variants.length; i++) {
      if (item.variants[i].available) return item.variants[i];
    }
    return item.variants[0];
  }

  function findVariant(item, variantId) {
    if (!item.variants || !item.variants.length) return null;
    var id = normalizeId(variantId);
    for (var i = 0; i < item.variants.length; i++) {
      if (normalizeId(item.variants[i].id) === id) return item.variants[i];
    }
    return null;
  }

  function buildVariantSelectHTML(item, selectedVariantId) {
    if (!item.variants || item.variants.length <= 1) return '';

    var label = getOptionLabel(item);
    var selectId = 'cyb-variant-' + item.productId;
    var optionsHtml = item.variants.map(function(variant) {
      var selected = normalizeId(variant.id) === normalizeId(selectedVariantId) ? ' selected' : '';
      var disabled = variant.available ? '' : ' disabled';
      return '<option value="' + variant.id + '" data-price="' + variant.price + '" data-formatted="' + escapeHtml(variant.priceFormatted) + '"' + selected + disabled + '>' +
        escapeHtml(getVariantDisplayLabel(variant, item)) + '</option>';
    }).join('');

    return (
      '<div class="cyb-item__variant">' +
        '<label class="cyb-item__variant-label" for="' + selectId + '">' + escapeHtml(label) + '</label>' +
        '<select id="' + selectId + '" class="cyb-item__variant-select" data-bundle-variant-select aria-label="Select ' + escapeHtml(label) + ' for ' + escapeHtml(item.title) + '">' +
          optionsHtml +
        '</select>' +
      '</div>'
    );
  }

  function buildItemHTML(item, isFirst, checked, selectedVariantId) {
    var variant = findVariant(item, selectedVariantId) || getFirstAvailableVariant(item);
    var imageHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="72" height="72" loading="lazy">'
      : '<div class="cyb-item__placeholder"></div>';
    var badge = isFirst ? '<span class="cyb-item__badge">Best Choice</span>' : '';
    var isChecked = checked !== false;

    return (
      '<div class="cyb-item' + (isFirst ? ' cyb-item--featured' : '') + (isChecked ? '' : ' cyb-item--unchecked') + '" data-bundle-item data-product-id="' + item.productId + '" data-variant-id="' + variant.id + '" data-price="' + (variant.price || 0) + '">' +
        '<label class="cyb-item__check">' +
          '<input type="checkbox" class="cyb-item__checkbox" data-bundle-checkbox' + (isChecked ? ' checked' : '') + ' aria-label="Include ' + escapeHtml(item.title) + ' in bundle">' +
          '<span class="cyb-item__checkmark" aria-hidden="true"></span>' +
        '</label>' +
        badge +
        '<a href="' + item.url + '" class="cyb-item__image" tabindex="-1">' + imageHtml + '</a>' +
        '<div class="cyb-item__body">' +
          '<a href="' + item.url + '" class="cyb-item__title">' + escapeHtml(item.title) + '</a>' +
          buildVariantSelectHTML(item, variant.id) +
        '</div>' +
        '<span class="cyb-item__price" data-bundle-item-price>' + escapeHtml(variant.priceFormatted || formatMoney(variant.price)) + '</span>' +
      '</div>'
    );
  }

  function applyVariantToRow(row) {
    var select = row.querySelector('[data-bundle-variant-select]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    if (!option || option.disabled) {
      for (var i = 0; i < select.options.length; i++) {
        if (!select.options[i].disabled) {
          select.selectedIndex = i;
          option = select.options[i];
          break;
        }
      }
    }
    if (!option) return;

    var price = normalizeId(option.getAttribute('data-price')) || 0;
    row.setAttribute('data-variant-id', option.value);
    row.setAttribute('data-price', price);

    var priceEl = row.querySelector('[data-bundle-item-price]');
    if (priceEl) {
      priceEl.textContent = option.getAttribute('data-formatted') || formatMoney(price);
    }
  }

  function getCartVariantIds(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(function(item) { return normalizeId(item.variant_id); });
  }

  function isVariantInCart(variantId) {
    return getCartVariantIds(lastCart).indexOf(normalizeId(variantId)) !== -1;
  }

  function getCheckedItemsFromDom() {
    var root = getRoot();
    if (!root) return [];
    var items = [];
    root.querySelectorAll('[data-bundle-item]').forEach(function(row) {
      var cb = row.querySelector('[data-bundle-checkbox]');
      if (!cb || !cb.checked) return;

      var select = row.querySelector('[data-bundle-variant-select]');
      if (select) applyVariantToRow(row);

      var variantId = normalizeId(row.getAttribute('data-variant-id'));
      var option = select ? select.querySelector('option[value="' + variantId + '"]') : null;
      if (option && option.disabled) return;

      items.push({
        productId: normalizeId(row.getAttribute('data-product-id')),
        variantId: variantId,
        price: normalizeId(row.getAttribute('data-price')) || 0
      });
    });
    return items;
  }

  function getItemsToAdd() {
    return getCheckedItemsFromDom().filter(function(item) {
      return !isVariantInCart(item.variantId);
    });
  }

  function updateBundleUI() {
    var root = getRoot();
    if (!root) return;

    var totalEl = root.querySelector('[data-bundle-total]');
    var btn = root.querySelector('[data-bundle-add]');
    var checked = getCheckedItemsFromDom();
    var toAdd = getItemsToAdd();

    root.querySelectorAll('[data-bundle-item]').forEach(function(row) {
      var cb = row.querySelector('[data-bundle-checkbox]');
      var inCart = isVariantInCart(row.getAttribute('data-variant-id'));
      row.classList.toggle('cyb-item--unchecked', cb && !cb.checked);
      row.classList.toggle('cyb-item--in-cart', inCart);
    });

    var total = checked.reduce(function(sum, item) { return sum + (item.price || 0); }, 0);
    if (totalEl) totalEl.textContent = formatMoney(total);

    if (!btn || btn.dataset.bundleBusy === 'true') return;

    btn.classList.remove('cyb__bundle-btn--success', 'cyb__bundle-btn--in-cart');

    if (!checked.length) {
      btn.disabled = true;
      btn.textContent = 'Select items to add';
      return;
    }

    if (!toAdd.length) {
      btn.disabled = true;
      btn.classList.add('cyb__bundle-btn--in-cart');
      btn.textContent = 'Already in your cart';
      return;
    }

    btn.disabled = false;
    btn.textContent = toAdd.length > 1 ? 'Add Bundle to Cart' : 'Add to Cart';
  }

  function resolveCart(source) {
    if (source && source.detail && source.detail.cart && source.detail.cart.items) {
      return Promise.resolve(source.detail.cart);
    }
    if (source && source.items) return Promise.resolve(source);
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function refreshCartState(source) {
    if (!getCatalogEl()) return Promise.resolve();
    return resolveCart(source).then(function(cart) {
      lastCart = cart;
      updateBundleUI();
    });
  }

  function getSectionsToRender() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function(section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function rememberAddedVariants(data, fallbackIds) {
    lastCart = lastCart || { items: [] };
    if (!lastCart.items) lastCart.items = [];

    var added = [];
    if (data && data.items && data.items.length) added = data.items;
    else if (data && (data.variant_id || data.id)) added = [data];

    if (added.length) {
      added.forEach(function(item) {
        lastCart.items.push({
          variant_id: item.variant_id || item.id,
          product_id: item.product_id
        });
      });
      return;
    }

    (fallbackIds || []).forEach(function(id) {
      lastCart.items.push({ variant_id: id });
    });
  }

  function updateCartDrawer(payload) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') cartDrawer.open();

    if (typeof cartDrawer.renderContents === 'function' && payload && payload.sections) {
      cartDrawer.renderContents(payload);
      return;
    }

    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      cartDrawerItems.onCartUpdate();
    }
  }

  function addBundle(btn) {
    if (!btn || btn.disabled || btn.dataset.bundleBusy === 'true') return;

    var toAdd = getItemsToAdd();
    if (!toAdd.length) {
      updateBundleUI();
      return;
    }

    var addedIds = toAdd.map(function(item) { return item.variantId; });
    btn.dataset.bundleBusy = 'true';
    btn.disabled = true;
    btn.classList.remove('cyb__bundle-btn--in-cart');
    btn.textContent = 'Adding...';

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: toAdd.map(function(item) { return { id: item.variantId, quantity: 1 }; }),
        sections: getSectionsToRender(),
        sections_url: window.location.pathname
      })
    }).then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok || data.status === 422 || data.status) {
          throw new Error(data.description || data.message || 'Could not add bundle');
        }
        return data;
      });
    }).then(function(data) {
      rememberAddedVariants(data, addedIds);
      btn.dataset.bundleBusy = 'false';
      updateBundleUI();
      updateCartDrawer(data);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-bundle',
          cartData: data
        });
      }
    }).catch(function(err) {
      btn.dataset.bundleBusy = 'false';
      updateBundleUI();
      alert(err.message || 'Try again');
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (btn) { e.preventDefault(); e.stopPropagation(); addBundle(btn); }
  });

  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-bundle-checkbox]')) {
      updateBundleUI();
      return;
    }
    if (e.target.matches('[data-bundle-variant-select]')) {
      var row = e.target.closest('[data-bundle-item]');
      if (row) applyVariantToRow(row);
      updateBundleUI();
    }
  });

  document.addEventListener('cart:updated', refreshCartState);
  document.addEventListener('cart:refresh', refreshCartState);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event && event.source === 'product-bundle') return;
      refreshCartState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartState);
  } else {
    refreshCartState();
  }
  document.addEventListener('page:loaded', refreshCartState);
})();
